import React from "react";
import {Dialog, DialogActions, DialogContent} from "@mui/material";
import {Button, Grid, TextField} from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import {isEmpty, parseQueryStringToArray} from "@util/utils";

const CrossClubWorkoutDatesDialog = props => {
    const {open, onClose, sourceData} = props;
    const {nickName, originalClubName, crossClubName, crossClubWorkoutQuantity, workoutDates} = sourceData || {};
    const dates = parseQueryStringToArray(workoutDates);
    const nickNameText = nickName || "-";
    const originalClubNameText = originalClubName || "-";
    const crossClubNameText = crossClubName || "-";
    const crossClubWorkoutQuantityText = crossClubWorkoutQuantity ?? 0;
    const workoutDateText = isEmpty(dates) ? "無跨店運動日期" : dates.join("\n");

    return (
        <Dialog className="simple-content dialog" open={open} onClose={onClose} fullWidth maxWidth="sm">
            <GradientColorHeader onClose={onClose}>跨店運動日期</GradientColorHeader>
            <DialogContent>
                <Grid spacing={2} container>
                    <Grid xs={6} item>
                        <TextField key={originalClubNameText} label="原店鋪" defaultValue={originalClubNameText}
                                   disabled fullWidth/>
                    </Grid>
                    <Grid xs={6} item>
                        <TextField key={crossClubNameText} label="跨店店鋪" defaultValue={crossClubNameText} disabled
                                   fullWidth/>
                    </Grid>
                    <Grid xs={6} item>
                        <TextField key={nickNameText} label="會員暱稱" defaultValue={nickNameText} disabled fullWidth/>
                    </Grid>
                    <Grid xs={6} item>
                        <TextField key={crossClubWorkoutQuantityText} label="跨店次數"
                                   defaultValue={crossClubWorkoutQuantityText} disabled fullWidth/>
                    </Grid>
                    <Grid xs={12} item>
                        <TextField key={workoutDateText} label="跨店運動日期" defaultValue={workoutDateText} disabled
                                   multiline
                                   rows={Math.max(dates.length, 3)} fullWidth/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    關閉
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CrossClubWorkoutDatesDialog;
